var _a;
import { createSlice } from '@reduxjs/toolkit';
import { name } from './constants';
var initialState = {
    data: {
        jokersMetaInfo: [],
    },
    loading: 'idle',
    error: null,
};
export var achievements = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        getJokersMetaInfoPending: function (state) {
            state.loading = 'pending';
            state.error = null;
        },
        getJokersMetaInfoSuccess: function (state, action) {
            state.loading = 'fulfilled';
            state.data.jokersMetaInfo = action.payload;
            state.error = null;
        },
        getJokersMetaInfoError: function (state, action) {
            state.loading = 'rejected';
            state.error = action.payload;
        },
    },
});
export var getJokersMetaInfoPending = (_a = achievements.actions, _a.getJokersMetaInfoPending), getJokersMetaInfoSuccess = _a.getJokersMetaInfoSuccess, getJokersMetaInfoError = _a.getJokersMetaInfoError;
